const POSITION_DETAILS_CARD = {
	order_type: {
		title: 'Order type',
		dataAid: 'orderTypeKey',
		valueDataAid: 'orderTypeValue',
	},
	exchange: {
		title: 'Exchange',
		dataAid: 'exchangeKey',
		valueDataAid: 'exchangeValue',
	},
	net_quantity: {
		title: 'Net quantity',
		dataAid: 'quantityKey',
		valueDataAid: 'quantityValue',
	},
	average_price: {
		title: 'Average price',
		dataAid: 'priceKey',
		valueDataAid: 'priceValue',
	},
	overall_pl: {
		title: 'Overall P&L',
		dataAid: 'overallPlKey',
		valueDataAid: 'overAllValue',
		value2DataAid: 'overAllPercentage',
	},
	today_pl: {
		title: 'Today’s P&L',
		dataAid: 'todayPlKey',
		valueDataAid: 'todayPlValue',
		value2DataAid: 'todayPlPercentage',
	},
};

const POSITION_BREAKUP_CARD = {
	cardId: 'data',
	header: {
		title: 'Position breakup',
		dataAid: 'header',
	},
	tableTitles: {
		order: {
			title: '',
			dataAid: 'orders',
		},
		qty: {
			title: 'Qty.',
			dataAid: 'qty',
		},
		avg_price: {
			title: 'Avg price',
			dataAid: 'avgPrice',
		},
		amount: {
			title: 'Amount',
			dataAid: 'amount',
		},
	},
	orderValue: {
		dataAid: 'orderData',
	},
	qtyValue: {
		dataAid: 'qtyData',
	},
	avg_price_value: {
		dataAid: 'avgPriceData',
	},
	amount_value: {
		dataAid: 'amountData',
	},
	today_buy: {
		title: 'Today’s buy',
	},
	today_sell: {
		title: 'Today’s sell',
	},
	carryforward: {
		title: 'Carryforward',
	},
	net: {
		title: 'Net',
	},
};

const CONVERT_POSITION_BOTTOMSHEET = {
	dataAid: 'convertPosition',
	primaryButtonTitle: 'Convert Position',
};

const BUTTON_GROUP = {
	primary: {
		openTitle: 'Add more',
		closeTitle: 'buy',
	},
	secondary: {
		openTitle: 'Square off',
		closeTitle: 'sell',
	},
};

const MISCELLANEOUS = {
	screenDataAid: 'positionDetails',
	headerDataAid: 'positionDetails',
	headerTitle: 'Position details',
	headerButton: {
		title: 'Market depth',
		dataAid: 'link',
	},
	squareOffButton: {
		title: 'Square off',
		dataAid: 'squareOffPositions',
	},
};

const TOASTS = {
	insufficientMargin: 'Insufficient Margin',
	eDISAuthorizationFailed: 'eDIS authorization failed. Please try again.',
};

const POSITION_DETAILS = {
	POSITION_DETAILS_CARD,
	POSITION_BREAKUP_CARD,
	CONVERT_POSITION_BOTTOMSHEET,
	BUTTON_GROUP,
	TOASTS,
	...MISCELLANEOUS,
};

export default POSITION_DETAILS;
